export default [
  { id: 'apnic-at-a-glance', name: 'At a Glance' },
  { id: 'apnic-rqc', name: 'Quality Check' },
  { id: 'apnic-routing', name: 'Routing' },
  { id: 'apnic-anti-abuse', name: 'Anti Abuse' },
  { id: 'apnic-database', name: 'Database' },
  { id: 'apnic-geo', name: 'Geographic' },
  { id: 'apnic-activity', name: 'Activity' },
  { id: 'apnic-comparison', name: 'Comparison' },
  // { id: 'apnic-experimental', name: 'Experimental' }
];
